<script setup>
import { RouterView } from "vue-router";
import Header from "@/components/HeaderComponent.vue";
import Footer from "@/components/FooterComponent.vue";
let props = defineProps(['appKey']);

</script>

<template>
  <div>
    <Header />

    <RouterView :appKey="props.appKey"> </RouterView>

    <Footer @rebuildApplication="$emit('rebuildApplication')" />
  </div>
</template>
